var render = function render(){var _vm=this,_c=_vm._self._c;return (true)?_c('div',{staticClass:"popup-iframe"},[_c('StoryIFrame',{key:_vm.story.id,attrs:{"story":_vm.story}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }